export default "__VITE_ASSET__j15JsAV4__"